// eslint-disable-next-line import/prefer-default-export
export const getUserAvatar = (user) => {
  return `https://avatars.dicebear.com/api/avataaars/${user.email}.svg
  `
}
